module.exports = __webpack_public_path__ + "static/media/video-close.42ab1256.svg";